import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogAnnulationComponent } from '../../components/dialog-annulation/dialog-annulation.component';
import { Dialog } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';

@Injectable()
export class OpenModalService {
  cancelModalSubscription: Subscription;
  constructor(private readonly _matDialog: MatDialog, private readonly dialog: Dialog) {}

  openModal(
    modalComponent: ComponentType<unknown> | TemplateRef<unknown>,
    data = null,
    matConfig: MatDialogConfig = {}
  ) {
    const defaultConfig = {
      maxWidth: '90%',
      panelClass: 'custom-dialog-container'
    };
    return this._matDialog.open(modalComponent, {
      ...defaultConfig,
      data,
      ...matConfig
    });
  }

  openModalDSD<T = unknown>(modalComponent: ComponentType<T>, data = null) {
    return this.dialog.open(modalComponent, { data });
  }

  closeModal(): void {
    this._matDialog.closeAll();
    if (this.cancelModalSubscription) {
      this.cancelModalSubscription.unsubscribe();
    }
  }

  openModalCancelPreapproval(
    isRoutedBacktoDashBoard?: boolean,
    scrollToTop?: boolean,
    returnUrl?: string
  ): MatDialogRef<unknown, any> {
    return this.openModal(DialogAnnulationComponent, {
      isPreautEnLigne: true,
      returnUrl: isRoutedBacktoDashBoard ? '' : returnUrl,
      scrollToTop
    });
  }
}
